import { render } from "./knowledgetype.vue?vue&type=template&id=1a26c43c"
import script from "./knowledgetype.vue?vue&type=script&lang=js"
export * from "./knowledgetype.vue?vue&type=script&lang=js"

import "./knowledgetype.vue?vue&type=style&index=0&id=1a26c43c&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__